import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getEpisodesByClassifictaion } from "@src/redux/action/planning/EpisodeAction";
import EpisodesCards from "./EpisodesCards";
import Filter from "@src/views/TuneIn/emission/Filter";
import BreadCrumbs from "@components/breadcrumbs/index1";

const EisodeByClassification = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [perPage, setPerpage] = useState(5);
  const episodesByClassification = useSelector(
    (state) => state.episodes.episodesByClassification
  );
  const EpisodeLastPage = useSelector(
    (state) => state.episodes.episodeLastPage
  );
  const { slug, name } = useParams();
  useEffect(() => {
    getEpisodesByClassifictaion(slug, dispatch, page, perPage);
  }, [dispatch, slug, page]);

  return (
    <div>
      <BreadCrumbs
        breadCrumbTitle={t("EPISODES WITH CLASSIFICATION") + ": " + name}
      />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "80%" }}>
          <div className="row">
            <Filter t={t} />
            <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
              <EpisodesCards
                episodesByClassification={episodesByClassification}
                setPage={setPage}
                EpisodeLastPage={EpisodeLastPage}
                t={t}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EisodeByClassification;
